import { Configuration } from "@azure/msal-browser";

import { currentEnvironment } from "../utils/environment";
import AuthenticationProvider from "./AuthenticationProvider";

// settings from Azure Portal
const frontendTenantId = "72f988bf-86f1-41af-91ab-2d7cd011db47";
const frontendClientId = currentEnvironment().clientId;

export const tdsWebApiScopes = [`${frontendClientId}/.default`];

const msalConfig: Configuration = {
  auth: {
    clientId: frontendClientId,
    authority: `https://login.microsoftonline.com/${frontendTenantId}`,
    redirectUri: `${window.location.origin}${process.env.PUBLIC_URL}`,
  },
  cache: {
    cacheLocation: "localStorage",
  },
};

export const getApiHeaders = async (): Promise<Headers> => {
  const token = await authProvider.getApiToken();
  const headers = new Headers({
    Accept: "application/json",
    "Content-type": "application/json",
  });
  headers.set("Authorization", `Bearer ${token.accessToken}`);
  return Promise.resolve(headers);
};

export const authProvider = new AuthenticationProvider(msalConfig);
